'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'face-thinking';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e39b';
var svgPathData = ['M0 256c0 18 1.9 35.6 5.4 52.5 8.3-2.9 17.3-4.5 26.6-4.5 38.7 0 71 27.5 78.4 64L224 368c44.2 0 80 35.8 80 80 0 25.8-12.3 48.8-31.3 63.5 133.6-8.6 239.3-119.7 239.3-255.5 0-141.4-114.6-256-256-256S0 114.6 0 256zM94.6 121.9c-5.5-9.6-2.1-21.8 7.4-27.3l13.1-7.5c32.9-18.8 73.6-17.4 105.1 3.6l30.9 20.6c9.2 6.1 11.7 18.5 5.5 27.7s-18.5 11.7-27.7 5.5L198 124.1c-18.9-12.6-43.3-13.4-63.1-2.2l-13.1 7.5c-9.6 5.5-21.8 2.1-27.3-7.4zM208 176a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM146 296c0-13.3 10.7-24 24-24l110 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-110 0c-13.3 0-24-10.7-24-24zM368 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M198 124.1l30.9 20.6c9.2 6.1 21.6 3.6 27.7-5.5s3.6-21.6-5.5-27.7L220.2 90.8c-31.5-21-72.2-22.4-105.1-3.6l-13.1 7.5c-9.6 5.5-12.9 17.7-7.4 27.3s17.7 12.9 27.3 7.4l13.1-7.5c19.7-11.3 44.1-10.4 63.1 2.2zM64 384c0-17.7-14.3-32-32-32S0 366.3 0 384L0 504c0 39.8 32.2 72 72 72l32 0c39.8 0 72-32.2 72-72l0-24 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-32zM208 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceThinking = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;